export default [
    {
        path: "/user",
        name: "User",
        component: () => import("@/views/user/user"),
        meta: {title: "用户管理", activeMenu: "/user"},
        access:'mainAccount',
    }
]
